<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = withDefaults(
  defineProps<{
    show: boolean;
    top: number;
    left: number;
  }>(),
  {
    show: false,
    top: 0,
    left: 0,
  },
);

const emit = defineEmits<{
  (event: 'update:show', value: boolean): void;
}>();

const menuEl = ref<HTMLElement | null>(null);

const handleClickOutside = (event: MouseEvent) => {
  if (!props.show) {
    return;
  }
  if (menuEl.value && !menuEl.value.contains(event.target as Node)) {
    emit('update:show', false);
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside, true);
  document.addEventListener('contextmenu', handleClickOutside, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside, true);
  document.removeEventListener('contextmenu', handleClickOutside, true);
});
</script>

<template>
  <div
    v-if="show"
    ref="menuEl"
    class="itp-router-context-menu"
    :style="{ top: `${top}px`, left: `${left}px` }"
    @click.stop="emit('update:show', false)"
  >
    <ul class="list-unstyled mb-0 py-1">
      <slot />
    </ul>
  </div>
</template>
